import { createAsyncThunk } from '@reduxjs/toolkit';
import { ChangeAdvertiseMediaPosition } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import {
  CreateChangeAdvertiseMediaPosition
} from './interface';

export const createChangeAdvertiseMediaPosition = createAsyncThunk(
  'changeAdvertiseMediaPosition/createChangeAdvertiseMediaPosition',
  async (values: CreateChangeAdvertiseMediaPosition, { rejectWithValue }) => {
    try {
      const response = await ChangeAdvertiseMediaPosition.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);